import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CrystalclearArchiveBackUrl} from "../config/crystalclear-archive-back-url";
import {ProfileAbsService} from "./profile-abs.service";

@Injectable({
  providedIn: 'root'
})
export class ReportProfileService extends ProfileAbsService {

  constructor(http: HttpClient,
    toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_REPORT_PROFILE_LIST,
      CrystalclearArchiveBackUrl.SAVE_ARCHIVE_REPORT_PROFILE,
      CrystalclearArchiveBackUrl.DELETE_ARCHIVE_REPORT_PROFILE,
      CrystalclearArchiveBackUrl.DOWNLOAD_ARCHIVE_REPORT_PROFILE_ASYNC,
      CrystalclearArchiveBackUrl.DOWNLOAD_FORPROFILE_ARCHIVE_REPORT_PROFILE_ASYNC,
      CrystalclearArchiveBackUrl.EXECUTE_ARCHIVE_REPORT_PROFILE_ASYNC,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_REPORT_PROFILE_EXPORT_TEMPLATES_FORM,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_REPORT_PROFILE_EXPORT_TEMPLATES_PROFILE,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_REPORT_PROFILE_PROFILES_FIELDS_FORM,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_REPORT_PROFILE_MAIL_TEMPLATES,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_REPORT_PROFILE_FILE_LOCATIONS,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_REPORT_BATCH_UPDATE);
  }

}
